import React, { useEffect } from 'react';
import { baseurl } from '../baseurl';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const CheckToken = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const verifyUser = async () => {
            const userToken = localStorage.getItem('userToken');
console.log('userToken', userToken);
            if (!userToken) {
                console.log("No token found, redirecting...");
                navigate('/login');
                return;
            }

            try {
    const response = await axios.get(`${baseurl}check-session`, {
        headers: { Authorization: `Bearer ${userToken}` }
    });

    console.log("Server Response:", response.data); // DEBUG 1

    if (response.data.success) {
        // Success! Do nothing or set user state
    } else {
        console.warn("Server said success: false"); // DEBUG 2
        handleLogout();
    }
} catch (error) {
    // DEBUG 3: See the actual error (401, 403, 500, etc.)
    console.error("Axios Error Details:", error.response?.data || error.message);
    handleLogout();
}
        };

        const handleLogout = () => {
            localStorage.removeItem('userToken');
            navigate('/login');
        };

        verifyUser();
    }, [navigate]);

    return null; 
};

export default CheckToken;